import Card from 'react-bootstrap/Card';

const Experience = (props)=>{
   const job = {
      hertz:{
         company:"Hertz", position:"Return Representative", date:"2024", img:"assets/img/icon/hertz.svg"
      },
      bsu:{
         company:"Boise State University", position:"Teaching Assistant", date:"Q1 2024", img:"assets/img/icon/bsuorange.svg"
      },
   }
   function Item(data){
      const {company, position, date, img} = data;
      return(
         <li className='experience-item'>
            <div className="date">
            <p>{date}</p>
            </div>
            <div className="info">
               <div className="icon">
                  <img src={img} alt={company +" logo"}/>
               </div>
               <div className="text">
                  <h4 className="title">{company}</h4>
                  <h6 className="subtitle">{position}</h6>
               </div>
            </div>
         </li>
      )
   }
   
   return(
     <>
      <Card className='experience-card'>
         <Card.Body>
            <Card.Title as="h3">
               Work Experience
            </Card.Title>
            <div className='experience-container scroll-container'>
               <ul className='experience-slider'>
                  {Item(job.hertz)}
                  {Item(job.bsu)}
               </ul>
               <ul className='experience-slider'>
                  {Item(job.hertz)}
                  {Item(job.bsu)}
               </ul>
            </div>
         </Card.Body>
      </Card>
     </>
   );
}
export default Experience;